import * as React from "react";
import { Input } from "./Input";

interface FormFieldProps extends React.InputHTMLAttributes<HTMLInputElement> {
  label: string;
  error?: string;
  helpText?: string;
}

const FormField = React.forwardRef<HTMLInputElement, FormFieldProps>(
  ({ label, error, helpText, id: idProp, ...props }, ref) => {
    const generatedId = React.useId();
    const id = idProp ?? generatedId;

    return (
      <div className="w-full">
        <label
          htmlFor={id}
          className="block text-sm font-medium text-ev-text-primary mb-1"
        >
          {label}
        </label>
        <Input id={id} ref={ref} {...props} />
        {error && (
          <p className="text-ev-danger-text text-sm mt-1" role="alert">
            {error}
          </p>
        )}
        {!error && helpText && (
          <p className="text-ev-text-muted text-sm mt-1">{helpText}</p>
        )}
      </div>
    );
  },
);
FormField.displayName = "FormField";

export { FormField };
